import { IAppState } from '@state/types';
import * as actionsInterfaces from './types'; 

export const getDesigns = (state: IAppState): any | undefined => state.designs.designs;

export const getDesign = (state: IAppState): any | undefined => state.designs.design;

export const getDesignAuth = (state: IAppState): actionsInterfaces.IDesignAuth | undefined => state.designs.designAuth;

export const getDesignAuthMailErrors = (state: IAppState): string[] | undefined => state.designs.designAuthMailErrors;

export const getDesignResponse = (state: IAppState): any | undefined => state.designs.designResponse;

export const getDesignSearch = (state: IAppState): any | undefined => state.designs.designSearches;

export const getDesignFavoriteResponse = (state: IAppState): any | undefined => state.designs.designFavoriteResponse;

export const getCounterDesigns = (state: IAppState): any | undefined => state.designs.counterDesigns;

export const getCounterSharedFiles = (state: IAppState): any | undefined => state.designs.counterSharedFiles;